import React, { createContext, useContext } from 'react';

import type { FeatureFlagList } from './index';

export type FlagOverrides = Partial<FeatureFlagList>;

type FeatureFlagOverridesContextProps = {
	flagOverrides: FlagOverrides;
};

const FeatureFlagOverridesContext = createContext<FeatureFlagOverridesContextProps>({
	flagOverrides: {},
});

export const useFeatureFlagOverrides: () => Partial<FeatureFlagList> = () => {
	const { flagOverrides } = useContext(FeatureFlagOverridesContext);

	return flagOverrides;
};

type FeatureFlagOverrideProps = {
	flagOverrides: FlagOverrides;
	children: React.ReactNode;
};

/**
 * __Feature flag override__
 *
 * Allows overriding feature flags, limited to a subtree of the application.
 */
export const FeatureFlagOverrides: ({
	flagOverrides,
	children,
}: FeatureFlagOverrideProps) => React.JSX.Element = ({
	flagOverrides,
	children,
}: FeatureFlagOverrideProps): React.JSX.Element => {
	return (
		<FeatureFlagOverridesContext.Provider
			value={{
				flagOverrides,
			}}
		>
			{/* Key on Fragment forces complete remount of children when path changes,
			    ensuring components that use fg() directly re-evaluate their flags */}
			{children}
		</FeatureFlagOverridesContext.Provider>
	);
};
